<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid" :columns="[
    'Cód. Anotação',
    'Anotação',
    'Cód. Origem',
    'Origem Info',
    'Data Anotação',
    'Data Ocorrência',
    'Valor Anotação',
    'PAC']" :showTipFooter="false" v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.idTipoAnotacao ? parseInt(obj.idTipoAnotacao).toString(): ''" />
        <TableColumn :IsText="true" :status="1" :value="obj.descricaoTipoAnotacao" />
        <TableColumn :IsText="true" :status="1" :value="obj.idOrigemInfo ? parseInt(obj.idOrigemInfo).toString(): ''" />
        <TableColumn :IsText="true" :status="1" :value="obj.descricaoOrigemInfo" />
        <TableColumn :IsText="true" :status="1" :value="obj.dataHoraAnotacao ? obj.dataHoraAnotacao : ''" />
        <TableColumn :IsText="true" :status="1" :value="obj.dataHoraOcorrencia ?obj.dataHoraOcorrencia : ''" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorAnotacao ? formatValue(obj.valorAnotacao) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.pac ? parseInt(obj.pac).toString(): ''" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import NegativeAnnotationsRepository from '@/shared/http/repositories/business/negativeannotations.js'

export default {
  name: 'NegativeAnnotations',
  mixins: [ActionsForm],
  methods: {
    onLoadNegativeAnnotations (document) {
      loading.push()
      NegativeAnnotationsRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/negativeannotations.vue